import Model, { attr } from '@warp-drive/legacy/model';
import type { Type } from '@warp-drive/core/types/symbols';

// Proto: attendance.LearnerNzMoeDays.
export default class NzMoeDaysByLearner extends Model {
  declare [Type]: 'attendance/nz-moe-days-by-learner';

  @attr('string', { defaultValue: '' })
  declare personId: string;

  // TS-STANDIN(proto attendance.NzMoeDay): raw attr holds plain JSON.
  @attr()
  declare nzMoeDays: unknown;
}
